export const TRANSLATION_SCOPE = 'permissionModule';
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
